import React, {useState} from "react";
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import Popup from "../../../component/Popup/Popup";
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@mui/material";
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import axios from "axios";
import {ApiUrl} from "../../../auth/authMethods";
import LoadingButton from "@mui/lab/LoadingButton";
import DownloadIcon from "@mui/icons-material/Download";
import SaveIcon from "@mui/icons-material/Save";

export default function PopupListUpdates({item}) {

    const [lgShow, setLgShow] = useState(false);
    const [downloadingList, setDownloadingList] = useState([])

    const button = <>
        <HistoryToggleOffIcon fontSize="medium"/>
        &nbsp; Alterações de Vencimento
    </>

    const title = "Alterações de Vencimento"

    const iconSpan = <>
        <HistoryToggleOffIcon fontSize="large" id="icon-svg"/>
        {title}
    </>

    const styleRow = {textAlign: 'center'}


    async function downloadFiles(alt) {
        setDownloadingList([...downloadingList, alt.id])

        for (const fileData of alt.files) {
            await downloadFile(fileData);
        }

        setDownloadingList(downloadingList.splice(downloadingList.indexOf(alt.id), 1))
    }

    async function downloadFile(fileData) {
        await axios.post(`${ApiUrl}/boletos/update-file/${fileData.id}`, {}, {responseType: 'arraybuffer'})
            .then(response => {
                const blob = new Blob([response.data], {type: 'application/octet-stream'});

                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = fileData.fileName;
                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
            })
            .catch(error => console.error('Erro ao gerar boleto:', error))
    }


    return <Popup
        buttonText={button}
        title={title}
        iconSpan={iconSpan}
        lgShow={lgShow} setLgShow={setLgShow}
        buttonClass='dropdown-item'
    >
        <br/>
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell style={styleRow}>Usuário</TableCell>
                        <TableCell style={styleRow}>Dia da Alteraçao</TableCell>
                        <TableCell style={styleRow}>Vencimento Original</TableCell>
                        <TableCell style={styleRow}>Novo Vencimento</TableCell>
                        <TableCell style={styleRow}>Arquivos</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>

                    {item.alteracaoVencimentoDto.map((alt) => (
                        <TableRow key={alt.id}>
                            <TableCell style={styleRow}>{alt.username}</TableCell>
                            <TableCell style={styleRow}>{normalizeTimestemp(alt.dateCreated)}</TableCell>
                            <TableCell style={styleRow}>{normalizeTimestemp(alt.oldDate)}</TableCell>
                            <TableCell style={styleRow}>{normalizeTimestemp(alt.newDate)}</TableCell>
                            <TableCell style={styleRow}>
                                <LoadingButton
                                    title='Fazer download do arquivo'
                                    loading={downloadingList.find(id => id === alt?.id)}
                                    onClick={() => downloadFiles(alt)}
                                    variant="text"
                                    loadingPosition="start"
                                    startIcon={<DownloadIcon/>}
                                    variant="text"
                                >
                                    <span>
                                        &nbsp;Baixar Evidências
                                    </span>
                                </LoadingButton>
                            </TableCell>
                        </TableRow>
                    ))}

                </TableBody>
            </Table>
        </TableContainer>

    </Popup>
}